<template>
  <exchange-dashboard
    :autoRefresh="true"
    :tableStats="stats"
    :graphStats="stats"
    :statBarStats="statBarStats"
    :table-fields="['bidder_name']">
  </exchange-dashboard>
</template>

<script>
    import ExchangeDashboard from '@/components/UserDashboard'

export default {
  name: 'DashboardExchange',
  data () {
    return {
      stats: ['auctions', 'bids', 'bid_rate', 'clears', 'clear_rate', 'timeout_rate', 'cost'],
      statBarStats: ['auctions', 'bids', 'clears', 'fill_rate', 'timeout_rate', 'cost'],
    }
  },
  components: {
    ExchangeDashboard
  }
}
</script>



// WEBPACK FOOTER //
// src/exchange/pages/Dashboard.vue